import { render, staticRenderFns } from "./Issue6.vue?vue&type=template&id=26ea9650&scoped=true&"
var script = {}
import style0 from "./Issue6.vue?vue&type=style&index=0&id=26ea9650&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ea9650",
  null
  
)

export default component.exports